var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-divider',_vm._b({attrs:{"content-position":_vm.dividerContentAlign}},'el-divider',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }